export default __webpack_public_path__ + "static/media/CIA-Debit-Order-Authority.0f99b6fb.pdf";